import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GetAccess } from "../../../Components/Utils/roles";
import SearchBar from "../../../Components/Utils/SearchBar";
import {
  ClearFilterButton,
  CreateButton,
  ExportButton,
  FilterButton,
  ImportButton,
} from "../../../Components/Utils/Buttons";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";

const InspectionLayout = ({
  getData = () => {},
  setSearchQuery = () => {},
  CreateAccess = false,
  ImportAccess = false,
  setOpen = () => {},
  setOpenExport = () => {},
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => {},
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
  neededSearch = false,
  showproject = true,
  isCard = true,
  setViewMode = () => {},
  viewMode = "",
  ExportAccess = false,
}) => {
  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname == `/inspection/calender`) {
      setModule("Calendar");
    } else if (pathname == `/inspection/schedule`) {
      setModule("Schedule");
    }
  }, [pathname]);

  let LinkItem = [
    {
      label: "Calendar",
      link: `/inspection/calender`,
      access: GetAccess(),
    },
    {
      label: "Schedule",

      link: `/inspection/schedule`,
      access: GetAccess(),
    },
  ];

  return (
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">
      <div className="md:flex justify-between w-full ">
         <Breadcrumb
                          items={[
                            { name: "Inspection" },
                           
                
                            { name: module },
                          ]}
                        />
      

        <div className=" flex justify-end items-center gap-3 ">
          <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            {neededSearch && (
              <SearchBar handleChange={searchFun} value={searchValue} />
            )}
          </form>

          {newfilter && (
            <>
              <FilterButton
                label="Filter"
                handleClick={() => {
                  setFilterOpen(true);
                  setSearchQuery("");
                }}
              />
              {isFilter && (
                <ClearFilterButton label="Clear" handleClick={ClearFilter} />
              )}{" "}
            </>
          )}
          {/* {ImportAccess && (
            <ImportButton label="Import" handleClick={() => setOpen(true)} />
          )}
          {ExportAccess && (
            <ExportButton
              label="Export"
              handleClick={() => setOpenExport(true)}
            />
          )}

          {CreateAccess && (
            <Link to={`${pathname}/create`}>
              <CreateButton label={module} />
            </Link>
          )} */}
        </div>
      </div>
                <div className={`w-full flex items-center gap-x-1 ${
    module === 'Calender' ? 'mt-2' : ''
  }`}>
      {LinkItem &&
        LinkItem.map((item, i) => {
          const isActive = item?.link === pathname;
          return (
            item.access && (
              <Link
                to={item?.link}
                key={item?.link}
                className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-1
                  ${isActive 
                    ? "bg-baseColor-primary text-white" 
                    : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                  }`}
              >
                {item?.label || ""}
              </Link>
            )
          );
        })}
    </div>
    
      <div className=" w-full h-[calc(100vh-165px)]  ">{children}</div>
    </div>
  );
};
export default InspectionLayout;
